import { useCommonStore, useUserStore } from "@/stores";
import styles from "./index.module.scss";
import clsx from "clsx";
import { GenerateSvg, GeneratingSvg } from "@/assets/icons";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { 
  COMMUNITY_EXP_TEMP_TITLE_PREFFIX,
  CREDIT_CONSUME, 
  CUS_EXP_TEMP_TITLE_PREFFIX, 
  LocalStorageKey, 
  PROJECT_TYPE 
} from "@/constants";
import { credits_png } from "@/assets/images";
import FTAnalytic from "@/analyze/FTAnalytic";
import MaiDianUtils from "@/utils/MaiDianUtils";

const GenerateButton = () => {
  const { t } = useTranslation();
  const generating = useCommonStore(state => state.generating);
  const sourceImgFile = useCommonStore(state => state.sourceImgFile);
  const generate = useCommonStore(state => state.generate);
  const loopTask = useCommonStore(state => state.loopTask);
  const fetchCredits = useUserStore(state => state.fetchCredits);
  const showPayment = useUserStore(state => state.showPayment);
  const showLogin = useUserStore(state => state.showLogin);
  const fetchVipStatus = useUserStore(state => state.fetchVipStatus);
  const setTask = useCommonStore(state => state.setTask);
  const setGenerating = useCommonStore(state => state.setGenerating);
  const activeExpTemp = useCommonStore(state => state.getters.activeExpTemp);
  
  const handleClick = async () => {
    setTask(null);
    setGenerating(true);
    MaiDianUtils.setExpTemp(activeExpTemp ? { ...activeExpTemp } : null);

    // 埋点
    FTAnalytic.addAnalytic({
      type: 'ev',
      action: 'fotor_web$click_up$swap_project_page_features',
      label: {
        button_position: "generate",
        project_type: PROJECT_TYPE,
      },
    });

    let resource_id;
    let resource_name;
    if (MaiDianUtils.expTemp?.id.startsWith(CUS_EXP_TEMP_TITLE_PREFFIX)) {
      resource_id = "customize";
      resource_name = "customize";
    } else if (MaiDianUtils.expTemp?.id.startsWith(COMMUNITY_EXP_TEMP_TITLE_PREFFIX)) {
      const url = new URL(window.location.href);
      resource_id = url.searchParams.get("temp");
      resource_name = "community";
    } else {
      resource_id = MaiDianUtils.expTemp?.id;
      resource_name = MaiDianUtils.expTemp?.title;
    }

    if (!localStorage.getItem(LocalStorageKey.userInfo)) {
      try {
        await showLogin({
          isSignIn: true,
          options: {
            position: 'generate',
          },
          isShowScenses: true
        });
      } catch (err) {
        console.error(err);
        setGenerating(false);

        // 埋点（未登录）
        FTAnalytic.addAnalytic({
          type: 'ev',
          action: 'fotor_web$callback$swap_project_results',
          label: {
            is_success: false,
            fail_reason: "no login",
            project_type: PROJECT_TYPE,
            resource_id,
            resource_name,
          },
        });

        return;
      }
    }

    const credits = await fetchCredits();

    if (credits < CREDIT_CONSUME) {
      await fetchVipStatus();

      try {
        await showPayment({
          position: "generate",
          otherParam: {
            scenesId: '032',
          },
        });
      } catch (err) {
        console.error(err);
        setGenerating(false);

        // 埋点（credit 不足）
        FTAnalytic.addAnalytic({
          type: 'ev',
          action: 'fotor_web$callback$swap_project_results',
          label: {
            is_success: false,
            fail_reason: "no credits",
            project_type: PROJECT_TYPE,
            resource_id,
            resource_name,
          },
        });

        return;
      }
    } 
    
    try {
      const isFailed = await generate();
      if (isFailed) {
        toast(t("community_temp_deleted"));

        // 埋点（创建任务失败）
        FTAnalytic.addAnalytic({
          type: 'ev',
          action: 'fotor_web$callback$swap_project_results',
          label: {
            is_success: false,
            fail_reason: "creation failed",
            project_type: PROJECT_TYPE,
            resource_id,
            resource_name,
          },
        });

        return;
      }
    } catch (err) {
      toast(t("file_upload_failed"));
      console.error(err);
      setGenerating(false);

      // 埋点（创建任务失败）
      FTAnalytic.addAnalytic({
        type: 'ev',
        action: 'fotor_web$callback$swap_project_results',
        label: {
          is_success: false,
          fail_reason: "creation failed",
          project_type: PROJECT_TYPE,
          resource_id,
          resource_name,
        },
      });

      return;
    }

    loopTask(
      0,
      () => {
        toast(t("task_failed_msg"));
      }
    );
  }
  
	return (
		<button
      className={clsx(
        styles['generate_button'],
        generating && styles["generating"]
      )}
      disabled={generating || !sourceImgFile}
      onClick={handleClick}
    >
      {generating ? (
        <GeneratingSvg></GeneratingSvg>
      ) : (
        <GenerateSvg></GenerateSvg>
      )}
      <span className={styles["text"]}>{generating ? t("generating") : t("generate_button")}</span>
      
      <span
        className={styles["credits_wrapper"]}
      >
        <img 
          className={styles["credits_img"]}
          src={credits_png} 
          alt="" 
          width={16}
          height={16}
        />
        <span
          className={styles["credits"]}
        >
          -{CREDIT_CONSUME}
        </span>
      </span>
    </button>
	);
};

export default GenerateButton;
